import { FC } from "react";
import cn from "classnames";
import { ISelectOption } from "src/@types/form";
import { ButtonSelectorItem } from "./ButtonSelectorItem";
import { IMultiButtonSelector } from "./types";

export const MultiButtonSelector: FC<IMultiButtonSelector> = ({
  className,
  selectorClassName,
  options,
  activeOptions,
  setActiveOptions,
}) => {
  const updateActiveOptions = (newOption: ISelectOption) => {
    if (activeOptions.some(({ value }) => newOption.value === value)) {
      setActiveOptions(
        activeOptions.filter(({ value }) => newOption.value !== value)
      );
    } else {
      setActiveOptions([...activeOptions, newOption]);
    }
  };

  return (
    <div className={cn("flex gap-4", className)}>
      {options.map((option) => (
        <ButtonSelectorItem
          key={option.id}
          className={selectorClassName}
          option={option}
          isSelected={activeOptions.some(
            (activeItem) => activeItem.value === option.value
          )}
          onClick={updateActiveOptions}
        />
      ))}
    </div>
  );
};
